import { isMobile } from '@/utils/mobile.util';

import SearchFilter from './view';
import SearchFilterMobile from './view.mobile';
export default isMobile ? SearchFilterMobile : SearchFilter;
